import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-checkbox-icon',
    imports: [],
    templateUrl: './checkbox-icon.component.html'
})
export class CheckboxIconComponent {
  @Input() imageClass?: string;
}
